import axios from 'axios'
import { Toast, Dialog } from 'vant';
import store from '@/store'
import { getToken, removeToken } from '@/utils/auth'
import { removeUser } from '@/utils/user'
import { getQueryVariable, getIndexUrl, getIndexPath } from '@/utils/app'
import package_config from '../../package.json'

const API_ROOT = process.env.VUE_APP_AXIOS_URL
// create an axios instance
const service = axios.create({
  baseURL: API_ROOT, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 15000, // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    //add app_id
    // if(store.state.app) {
    //   let app_id = store.state.app.id
    //   if(app_id)config.data = {app_id, ...config.data}
    //   if(config.method == 'get') {
    //     config.params = {app_id, ...config.data}
    //   }
    // }
    // config.headers['Content-Type'] = 'application/json'
    config.url += '?v=' + package_config.version
    if(config.url.indexOf('json')>=0) config.baseURL = '/'
    let token = getToken();
    if(token)config.headers['Authorization'] = 'Bearer ' + getToken()
    console.log(token)
    let app = 'dt'
    let q = process.env.VUE_APP_Q
    config.data = {app, q, ...config.data}

    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    if (res.code == 401) {
      removeToken()
      window.location.href = getIndexPath(store.state.acc.code)
      return Promise.reject()
    }else if(res.code == 400){
      Dialog.alert({
        title: '提示',
        message: res.message,
        showCancelButton: true
      }).then(res=> {
        if(res.message.indexOf('刷新')>=0) {
          location.reload()
        }
      })
    }else if(res.code == 200){
      return res.data
    }else if(res.code == 201){
      return res
    }else if(res.status == 200){
      return res.data
    }else{
      Dialog.alert({
        title: '提示',
        message: '当前人数过多，请稍后再试',
        showCancelButton: true
      })
    }
  },
  error => {
    console.log(error) // for debug
    if(error.response) {
      Dialog.alert({
        title: '提示',
        message: '当前人数过多，请稍后再试',
        showCancelButton: true
      })
    }else{
      Dialog.alert({
        title: '提示',
        message: '网络错误，请关闭页面，重新打开',
        showCancelButton: true
      })
    }
    return Promise.reject(error)
  }
)

export default service
